﻿const guideInitialState = {
    formData: {
        age: 0,
        startedWorkAge: 0,
        occupation: '',
        occupationalPlan: '',
        monthlySalary: '',
        wantedMonthlyPension: 0,
        family: ''
    }
};

export function retirementGuideFormData(state = guideInitialState, action) {
    switch (action.type) {
        case 'RETIREMENT_GUIDE_UPDATE_FORM_DATA':
            return { formData: {...state.formData, ...action.formData } };
        default:
            return state;
    }
}

export function retirementGuideChartData(state = {}, action) {
    switch (action.type) {
        case 'RETIREMENT_GUIDE_UPDATE_CHART_DATA':
            return { chartData: {...state.chartData, ...action.chartData } };
        default:
            return state;
    }
}
